import React from "react";
import Modal from "react-bootstrap/Modal";
export const GenericModal = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.modalClose}
      size={props.size}
      centered
      scrollable={true}
      className={props.cls}
      backdrop="static"
    >
      <Modal.Header className="modal-header-background">
        {/* <Modal.Title
                      className={
                        !props.tableExpand
                          ? "header-position-rapid"
                          : "header-expand-position-rapid"
                      }
                    >
                      {!props.memberHeader
                        ? "Application Status Summary"
                        : "Membership Status Summary"}
                    </Modal.Title> */}
        {/* <a class="mr-left-50"
                      // class="close"
                      onClick={props.tableExpandHandler}
                    >
                      {!props.tableExpand ? (
                        <OpenWithSharpIcon />
                      ) : (
                        <CompareArrowsIcon />
                      )}
                    </a> */}
        <button type="button" class="close" onClick={props.modalClose}>
          &times;
        </button>
      </Modal.Header>

      <Modal.Body>
        {console.log("-up", props.form, props.show)}
        {props.form}
      </Modal.Body>

      <Modal.Footer>
        {/* <Button variant="secondary" onClick={props.modalClose}>
            Close
          </Button> */}
      </Modal.Footer>
    </Modal>
  );
};
